import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon CaretRightIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const CaretRightIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 11 20">
      <path d="M2.2 20a2.16 2.16 0 01-1.43-.54 2.24 2.24 0 01-.24-3.13L5.9 10 .53 3.67A2.24 2.24 0 01.77.54a2.17 2.17 0 013.1.24l6.6 7.77a2.24 2.24 0 010 2.9l-6.6 7.77A2.16 2.16 0 012.2 20z" />
    </Icon>
  )
}
export default CaretRightIcon
